import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { UserForm } from 'components/Forms';
import { useStyles } from './styles';

const User: FC<any> = observer(({ type }) => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <UserForm type={type} />
    </Container>
  );
});

export default User;
